import { render, staticRenderFns } from "./TaskRawEditor.vue?vue&type=template&id=5ed3bf29&scoped=true"
import script from "./TaskRawEditor.vue?vue&type=script&lang=js"
export * from "./TaskRawEditor.vue?vue&type=script&lang=js"
import style0 from "./TaskRawEditor.vue?vue&type=style&index=0&id=5ed3bf29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed3bf29",
  null
  
)

export default component.exports